import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import "./ErrorNotification.css";
import * as AppActions from "../data/app/AppActions.js";
import { t } from "../locales";

const ErrorNotification = ({ error, clearError }) => {
  const timerRef = useRef(null);

  useEffect(() => {
    // When a new error appears, set a timer to clear it
    if (error) {
      // Clear any existing timer
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      // Set new timer to clear error after 3 seconds
      timerRef.current = setTimeout(() => {
        clearError();
      }, 3000);
    }

    // Clean up timer on unmount or when error changes
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [error, clearError]);

  const handleDismiss = () => {
    // Clear timer and error immediately if user clicks to dismiss
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    clearError();
  };

  if (!error) {
    return null;
  }

  // Translate the error message using the translation key
  const translatedError = t(error);

  return (
    <div className="error-notification">
      <div className="error-notification-content">
        <span className="error-notification-text">{translatedError}</span>
        <button
          className="error-notification-close"
          onClick={handleDismiss}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  error: state.app.error,
});

const mapDispatchToProps = (dispatch) => ({
  clearError: () => dispatch(AppActions.clearError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorNotification);
